import axios from "axios";
import { Notification, NotificationError } from "@/util/noty";

export default {
  state: {
    stateStatus: [],
  },
  getters: {
    stateStatus: (state) => state.stateStatus,
  },
  mutations: {
    _setStatus(state, data) {
      state.stateStatus = data;
    },
  },
  actions: {
    actionListarStatus({ commit }) {
      axios
        .get(`${process.env.VUE_APP_API}/status/listar-status`)
        .then((response) => {
          if (response.data.success) {
            commit("_setStatus", response.data.data.status);
            return response.data.data.status;
          } else {
            Notification(
              "danger",
              response.data.data.message.title,
              response.data.data.message.description
            );
          }
        })
        .catch((error) => {
          NotificationError();
          throw error.response.data;
        })
        .finally(() => {
          commit("setLoading", false);
        });
    },
  },
};
